const sta = {
  INSUFFICIENT_BALANCE: {
    message: 'Your balance is insufficient',
    field: 'value',
    code: 'STA_1'
  },
  WITHDRAW_VALUE_REQUIRED: {
    message: 'Enter the amount to withdraw',
    field: 'value',
    code: 'STA_2'
  }
};

module.exports = sta;
